import { DatePicker } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

// isoWeek needed for Monday-based week semantics; safe to call multiple times.
dayjs.extend(isoWeek)

const { RangePicker } = DatePicker

interface Props {
    value?: [Dayjs | null, Dayjs | null] | null
    onChange?: (dates: [Dayjs | null, Dayjs | null] | null, dateStrings: [string, string]) => void
    style?: React.CSSProperties
}

const presets = [
    { label: 'Hôm nay', value: [dayjs().startOf('day'), dayjs().endOf('day')] as [Dayjs, Dayjs] },
    { label: 'Hôm qua', value: [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')] as [Dayjs, Dayjs] },
    { label: '3 ngày qua', value: [dayjs().subtract(2, 'day').startOf('day'), dayjs().endOf('day')] as [Dayjs, Dayjs] },
    { label: 'Tuần này', value: [dayjs().startOf('isoWeek'), dayjs().endOf('isoWeek')] as [Dayjs, Dayjs] },
    { label: 'Tuần trước', value: [dayjs().subtract(1, 'week').startOf('isoWeek'), dayjs().subtract(1, 'week').endOf('isoWeek')] as [Dayjs, Dayjs] },
    { label: 'Tháng này', value: [dayjs().startOf('month'), dayjs().endOf('month')] as [Dayjs, Dayjs] },
    { label: 'Tháng trước', value: [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')] as [Dayjs, Dayjs] },
]

export default function DateRangePresets({ value, onChange, style }: Props) {
    return (
        <RangePicker
            value={value as any}
            onChange={onChange as any}
            presets={presets as any}
            format='DD/MM/YYYY'
            style={{ minWidth: 300, ...style }}
            allowClear
        />
    )
}
